// See analysis/pot-estimator-basketball
const potEstimator = (ovr: number, age: number, _pos?: string) => {
	if (age >= 29) {
		return ovr;
	}

	return 72.31428908571982 + -2.33062761 * age + 0.83308748 * ovr;
};

export default potEstimator;
